import styled from "styled-components";
import { useEffect, useState } from "react";
import Login from "./Login";
import { Redirect, Route, Switch } from "react-router-dom";
import SnsLogin from "./SnsLogin";
import Main from "./Main";
import StoreDetail from "./StoreDetail";
import EventPage from "./Event";
import EventDetail from "./EventDetail";
import Recruit from "./Community/Recruit";
import TournamentSchedule from "./TournamentSchedule";
import RecruitDetail from "./RecruitDetail";
import TournamentDetail from "./TournamentDetail";
import HoldemGuide from "./HoldemGuide";
import Youtube from "./Youtube";
import OpenChatList from "./OpenChat";
import OddsCalc from "./OddsCalc";
import SecondHandMarket from "./Community/SecondHandMarket";
import SecondHandMarketDetail from "./SecondHandMarketDetail";
import NewsDetail from "./NewsDetail";
import Community from "./Community";
import ArticleDetail from "./ArticleDetail";
import { PopupProvider } from "../../provider/PopupContext";
import ReservationLandingPage from "./ReservationLandingPage";
import CompetitionTournamentDetail from "./CompetitionTournamentDetail";
import RedirectPage from "./RedirectPage";
import NewSearch from "./NewSearch";
import FranchisePubs from "./FranchisePubs";
import CompanyReservation from "./CompanyReservation";
import MyReservation from "./MyReservation";
import useNativeApp, { isApp } from "../../hooks/useNativeApp";
import { useSetRecoilState } from "recoil";
import { insetState } from "../../recoil/inset";
import TournamentState from "./TournamentState";
import EventSchedule from "./EventSchedule";
import News from "./News";
import Schedule from "./Schedule";
import { CompetitionProvider } from "./Schedule/hook/competitionContext";
import { MEDIA_DESKTOP } from "../../hooks/useScreenOrientation";
import PremiumPub from "./PremiumPub";
import { PubProvider } from "./PremiumPub/hooks/pub-context";
import RabbitFestival from "./RabbitFestival";
import { RabbitFestivalProvider } from "./RabbitFestival/hooks/festival-context";
import Marketing from "./Marketing";
import Search from "./Search";
import OddsCalcAi from "./OddsCalc/ai";
import Reservation from "./reservation";

const WebWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;

  > .inner {
    position: relative;
    height: 100%;
    width: 100%;
    max-width: 500px;
    @media ${MEDIA_DESKTOP} {
      max-width: unset;
      overflow-y: scroll;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }
  }
`;
const Web = () => {
  const [initialized, setInitialized] = useState(false);
  const { sendMessageToNative } = useNativeApp();
  const setInset = useSetRecoilState(insetState);
  useEffect(() => {
    // Init iamport
    if (window.IMP) {
      window.IMP.init(process.env.REACT_APP_IAMPORT_USER_CODE!);
    }

    setInitialized(true);
    if (isApp) {
      setTimeout(() => {
        sendMessageToNative("appInsetTop", "getAppInsetTop", {
          data: "OK",
        })
          .then((res: any) => {
            setInset(res.top);
          })
          .catch((e) => {
            console.log(e);
          });
      }, 500);
    }
  }, []);

  if (!initialized) {
    return null;
  }

  return (
    <PopupProvider>
      <WebWrapper>
        <div className="inner">
          <Switch>
            <Route
              path="/mobile/:path*"
              render={({ location }) => (
                <Redirect to={location.pathname.replace("/mobile/", "/")} />
              )}
            />
            <Route path={["/null", "/undefined"]} exact>
              <Redirect to="/" />
            </Route>
            <Route path="/redirect">
              <RedirectPage />
            </Route>
            <Route path={"/"} exact>
              <Main />
            </Route>
            <Route path={"/home"} exact>
              <Main />
            </Route>

            <Route path={"/tournament/:id"} exact>
              <TournamentState />
            </Route>
            <Route path={"/pub"} exact>
              <FranchisePubs />
            </Route>
            <Route path={"/search"} exact>
              <Search />
            </Route>
            <Route path={"/name"} exact>
              <Main />
            </Route>
            <Route path={"/wallet"} exact>
              <Main />
            </Route>
            <Route path={"/rank"} exact>
              <Main />
            </Route>
            <Route path={"/seed"} exact>
              <Main />
            </Route>
            <Route path={"/mypage"} exact>
              <Main />
            </Route>
            <Route path={"/alarm"} exact>
              <Main />
            </Route>
            <Route path={"/login"} exact>
              <Login />
            </Route>
            <Route path={"/snslogin/:type"} exact>
              <SnsLogin />
            </Route>
            <Route path={"/logout"} exact>
              <Redirect to="/" />
            </Route>
            <Route path={"/event-schedule"} exact>
              <EventSchedule />
            </Route>
            <Route path={"/event/list"} exact>
              <EventPage />
            </Route>
            <Route path={"/event/detail/:id"} exact>
              <EventDetail />
            </Route>
            <Route path={"/tournamentSchedule"} exact>
              <TournamentSchedule />
            </Route>
            <Route path={"/openChat"} exact>
              <OpenChatList />
            </Route>
            <Route path={"/my-reservation/:id?"} exact>
              <MyReservation />
            </Route>
            <Route path={"/reservation-landing/:id"} exact>
              <ReservationLandingPage />
            </Route>
            <Route path={"/reservation/:id"} exact>
              <Reservation />
            </Route>
            <Route path={"/company-reservation/:id"} exact>
              <CompanyReservation />
            </Route>
            <Route path={"/holdem/guide"} exact>
              <HoldemGuide />
            </Route>
            <Route path={"/youtube"} exact>
              <Youtube />
            </Route>
            <Route path={"/holdemNow"} exact>
              <Main />
            </Route>
            <Route path={"/rabbit"} exact>
              <RabbitFestivalProvider>
                <RabbitFestival />
              </RabbitFestivalProvider>
            </Route>
            <Route path={"/tournament/detail/:type/:id"} exact>
              <TournamentDetail />
            </Route>
            <Route path={"/calc"} exact>
              <OddsCalc />
            </Route>
            <Route path={"/calc/ai"} exact>
              <OddsCalcAi />
            </Route>
            <Route path={"/signup"} exact>
              <Login />
            </Route>
            <Route path={"/like"} exact>
              <Main />
            </Route>
            <Route path={"/recruit"} exact>
              <Recruit />
            </Route>
            <Route path={"/recruit/detail/:id/:type"} exact>
              <RecruitDetail />
            </Route>
            <Route path={`/store/:id`} exact>
              <StoreDetail />
            </Route>
            <Route path={`/mobile/store/:id`} exact>
              <StoreDetail />
            </Route>
            <Route path={"/second-hand-market"} exact>
              <SecondHandMarket />
            </Route>
            <Route path={"/second-hand-market/detail/:id"} exact>
              <SecondHandMarketDetail />
            </Route>
            <Route path={"/news-detail/:id"} exact>
              <NewsDetail />
            </Route>
            <Route path={"/community/:tab?/:subTab?"} exact>
              <Community />
            </Route>
            <Route path={"/article/detail/:role/:id"} exact>
              <ArticleDetail />
            </Route>
            <Route path={"/news"} exact>
              <News />
            </Route>
            <Route path={"/marketing"} exact>
              <Marketing />
            </Route>
            <CompetitionProvider>
              <Route path={"/schedule"} exact>
                <Schedule />
              </Route>
              <Route path={"/competition-detail/:id"} exact>
                <CompetitionTournamentDetail />
              </Route>
            </CompetitionProvider>
          </Switch>
        </div>
      </WebWrapper>
    </PopupProvider>
  );
};

export default Web;
